<template>
  <div>
    <div class="login_modal" @touchmove.prevent v-if="modalDate" @click="modalshow()">
      <div class="modal_conter">
        <div class="modal_code">
          <div class="code_one">
            <img src="../assets/openewmtit.png" alt="" srcset="">
          </div>
          <div class="code_two">
            扫描二维码下载APP
          </div>
        </div>
      </div>
    </div>
    <div class="first_box">
      <div class="first_box_fixed">
        <div class="first_box_title">
        <div class="box_title_content">
          <div class="title_content_left">
            <div class="content_left_icon">
              <img src="../assets/logo.png" alt="" srcset="">
            </div>
            <div class="content_left_text">
              <img src="../assets/invite_toplo.png" alt="" srcset="">
            </div>
          </div>
          <div class="title_content_right" @click="findmessagedialog">
              <!-- <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane label="首页" name="first"></el-tab-pane>
                <el-tab-pane label="找粮商家入驻" name="second"></el-tab-pane>
                <el-tab-pane label="热点资讯" name="third"></el-tab-pane>
                <el-tab-pane label="帮助中心" name="fourth"></el-tab-pane>
                <el-tab-pane label="举报平台" name="fourts"></el-tab-pane>
                <el-tab-pane label="查快递" name="fourths"></el-tab-pane>
              </el-tabs> -->
              <div class="content_right_index">首页</div>
              <div class="content_line"></div>
              <div>产品介绍</div>
              <div class="content_line"></div>
              <div>商家特权</div>
              <div class="content_line"></div>
              <div>入驻流程</div>
              <div class="content_line"></div>
              <div>登录</div>
          </div>
        </div>
        </div>
        <div class="frist_box_line">
        </div>
        <div class="first_box_code">
          <div class="box_code_content">
            <div class="code_content_img">
              <div class="content_img_box">
                <img src="../assets/openewmtit.png" alt="" srcset="">
              </div>
            </div>
            <div class="code_content_text">
              <div>扫码下载</div>
              <div>App专享优惠</div>
            </div>
          </div>
        </div>
      </div>
      <div class="frist_box_content">
        <div class="box_content_banner">
          <div class="content_banner_img">
            <img src="../assets/open_app1(1).png" alt="" srcset="">
          </div>
          <div class="content_banner_text">
            <div class="banner_text_top">
              <img src="../assets/hyzxsszh-min.png" alt="" srcset="">
            </div>
            <div class="banner_text_bottom">立即下载</div>
          </div>
        </div>
        <div class="box_content_info">
          <div class="content_info_list">
            <div class="info_list_title">
              <div>现货信息</div>
              <!-- <div></div> -->
            </div>
            <div class="info_list_conter" @click="modalHide()">
              <div class="list_conter_img">
                <img src="../assets/list01.png" alt="" srcset="">
              </div>
              <div class="list_conter_img">
                <img src="../assets/list02.png" alt="" srcset="">
              </div>
              <div class="list_conter_img">
                <img src="../assets/list03.png" alt="" srcset="">
              </div>
              <div class="list_conter_img">
                <img src="../assets/list04.png" alt="" srcset="">
              </div>
            </div>
            <div class="info_list_conter" @click="modalHide()">
              <div class="list_conter_img">
                <img src="../assets/list05.png" alt="" srcset="">
              </div>
              <div class="list_conter_img">
                <img src="../assets/list06.png" alt="" srcset="">
              </div>
              <div class="list_conter_img">
                <img src="../assets/list07.png" alt="" srcset="">
              </div>
              <div class="list_conter_img">
                <img src="../assets/list08.png" alt="" srcset="">
              </div>
            </div>
            <div class="conter_rz"  @click="modalHide()">我要发布</div>
            <div class="info_list_title">
              <div>产品介绍</div>
              <!-- <div></div> -->
            </div>
            <div class="info_list_text">
              <div class="list_text_left">
                <p>
                  提供和粮食贸易相关的产品和服务的平台。通过网上平台将粮食供应商和粮食加工企业直接联系在一起，同时提供物流运输、仓储、供应链金融等第三方服务，以及大数据分析等IT服务。业务的价值在于减少传统粮食贸易的中间环节，将粮食贸易相关的服务商整合到一个平台上，有效降低买卖双方的信息不对称程度，提升其运转效率。
                </p>
              </div>
              <div class="list_text_right">
                <img src="../assets/phone02.png" alt="">
              </div>
            </div>
            <div class="info_list_code">
              <div class="list_code_img">
                <img src="../assets/openewmtit.png" alt="" srcset="">
              </div>
              <div class="list_code_text">扫描二维码下载APP</div>
            </div>
          </div>
        </div>
        <div class="frist_box_foot">
          <div class="box_foot_text">合肥预见未来信息科技有限公司</div>
          <div class="box_foot_text">公司地址：合肥市蜀山区高新技术开发区超远科技园C栋206</div>
          <div class="box_foot_text">联系电话：0551-65353167</div>
          <div class="box_foot_text">公司邮箱：postmaster@foresee-future.com</div>
          <div class="box_foot_text">
            <div class="imgs"><img src="../assets/wanicon.png" alt=""></div>
            <div class="infos">皖ICP备2021000115号-1</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>


export default {
  // 定义属性
  data() {
    return {
      // activeName: 'first'
      modalDate:false,
    }
  },
  // 计算属性，会监听依赖属性值随之变化s
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    // handleClick(tab, event) {
    //     console.log(tab, event);
    //   }
    findmessagedialog(promessage) {
      let othermessage;
        othermessage = this.$router.resolve({
          path: '/login',
          query: {
          },
        })
      window.open(othermessage.href, '_blank')
    },
    loginTo() {
      this.loginDate = !this.loginDate
    },
    modalHide() {
      this.modalDate = !this.modalDate
      this.stop()
    },
    modalshow(){
      this.modalDate = !this.modalDate
      this.move()
    },
        //禁止滚动
    stop(){
      var mo=function(e){
　　  e.preventDefault();
　　     };
      document.body.style.overflow='hidden';
      document.addEventListener("touchmove",mo,false);//禁止页面滑动
    },
    //取消滑动限制
    move(){
        var mo=function(e){
　　　　　　e.preventDefault();
　　　　　};
        document.body.style.overflow='';//出现滚动条
        document.removeEventListener("touchmove",mo,false);
    },
  },
  components: {

  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {

  },
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {}, // 生命周期 - 挂载之前
  beforeUpdate() {}, // 生命周期 - 更新之前
  updated() {}, // 生命周期 - 更新之后
  beforeDestroy() {}, // 生命周期 - 销毁之前
  destroyed() {}, // 生命周期 - 销毁完成
  activated() {}, // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>

<style scoped>
*{
  margin: 0;
  padding: 0;
}
/* html,body{
  width: 100%;
  height: 100%;
} */
.login_modal {
  position: fixed;
  width: 100%;
  height: 100%;
  background-color: #00000080;
  z-index: 999;
}
::-webkit-scrollbar {
  width: 0 !important;
}
::-webkit-scrollbar {
  width: 0 !important;height: 0;
}
.modal_conter {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
  width: 4.55rem;
  height: 5.65rem;
  background-image:url(../assets/opencornmodalback.png);
  background-repeat: no-repeat;
  background-size:4.55rem 5.65rem;
}
.modal_code {
  width: 4rem;
  height: 4rem;
  margin: auto;
  /* border: 1px solid #2D2D2D; */
}
.code_one {
  margin:.6rem auto;
  margin-top: 2.15rem;
  width: 2.22rem;
  height: 2.22rem;
  /* border: 1px solid #2D2D2D; */
}
.code_two {
  font-size: .18rem;
  color: #6E6E6E;
  font-weight: 600;
  text-align: center;
}
.first_box {
  /* width: 18.8rem;
  height: 10rem; */
  /* background: #FF6E00; */
}
.first_box_fixed {
  width: 100%;
  position: fixed;
  top: 0;
}
.first_box_title {
  height: 1.045rem;
  border: 1px solid #fff;
  background: #fff;
}
.box_title_content {
  margin: auto;
  display: flex;
  width: 63%;
  height: 100%;
  /* border: 1px solid #FF6E00; */
}
.title_content_left {
  margin: auto 0;
  display: flex;
  width: 3rem;
  height: .61rem;
  /* border: 1px solid #FF6E00; */
}
.title_content_right {
  display: flex;
  margin:auto 0;
  width: 8.8rem;
  height: .3rem;
  line-height: .3rem;
  font-size: 0.16rem;
  cursor: pointer;
  /* border: 1px solid #FF6E00; */
}
.content_right_index {
  font-weight: 600;
  color: #FF9127;
}
.content_left_icon {
  width: 0.61rem;
  height: 0.61rem;
  /* border: 1px solid #FF6E00; */
}
.content_left_icon img {
  width: 0.61rem;
  height: 0.61rem;
}
.content_left_text {
  margin-left: .1rem;
  width: 1.5rem;
  height: .6rem;
  /* border: 1px solid #FF6E00; */
}
.content_left_text img {
  width: 1.5rem;
  height: .6rem;
}
>>>.el-tabs__item.is-active {
  color: #FF6E00;
}
>>>.el-tabs__item:hover {
  color: #FF6E00;
}
>>>.el-tabs__active-bar {
  background-color: #FF6E00;
}
>>>.el-tabs__item {
  font-size: 16px;
}
>>>.el-tabs__nav-wrap::after {
  background: none;
}
.frist_box_line {
  /* width: 100vw; */
  width: 100%;
  /* width: 18.8rem; */
  height: .045rem;
  background: #FF6E00;
}
.first_box_code {
  position: fixed;
  top: 6.1rem;
  width: 1.6rem;
  height: 2.15rem;
  line-height: 2.15rem;
  background: #FFF;
  /* border: 1px solid burlywood; */
}
.box_code_content {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
  width: 1.4rem;
  height: 1.95rem;
  border: 0.02rem solid #FFE6D3;
}
.code_content_img {
  width: 1.4rem;
  height: 1.5rem;
  /* border: 0.02rem solid red; */
}
.content_img_box {
  position: relative;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
  width: 1.1rem;
  height: 1.1rem;
}
.content_img_box img{
  width: 1.1rem;
  height: 1.1rem;
}
.code_content_text {
  /* text-align: center; */
  width: 1.4rem;
  height: .44rem;
  /* line-height: .22rem; */
  /* border: 1px solid black; */
}
.code_content_text div{
  font-size: 0.14rem;
  text-align: center;
  width: 1.4rem;
  height: .2rem;
  line-height: .15rem;
  /* border: 1px solid black; */
}

.content_line {
  margin: auto 0.10rem;
  width: 0.01rem;                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                       
  height: 0.18rem;
  background:#6c6c6c;
}
.frist_box_content {
  padding-top: 1.09rem;
  width: 100%;
  /* width: 100vw; */
  height: 4.44rem;
  background: #FF9127;
}
.box_content_banner {
  display: flex;
  margin: 0 auto;
  margin-top: 0.59rem;
  width: 9rem;
  height: 3.84rem;
  /* border: 1px solid royalblue; */
}
.content_banner_img {
  width: 3.3rem;
  height: 3.84rem;
  /* border: 1px solid royalblue; */
}
.content_banner_img img{
  margin-top: .05rem;
  width: 3.3rem;
  height: 3.84rem;
}
.content_banner_text {
  margin-left: 1.45rem;
  width: 3.3rem;
  height: 3.84rem;
  /* border: 1px solid royalblue; */
}
.banner_text_top {
  margin-top: 0.5rem;
  width: 3.3rem;
  height: 1.5rem;
  /* border: 1px solid royalblue; */
}
.banner_text_top img{
  width: 3.3rem;
  height: 1.5rem;
}
@font-face {
	font-family: 'YouSheBiaoTiHei';
	src: url(../font/YouSheBiaoTiHei-2.ttf);
}
.banner_text_bottom {
  font-family: YouSheBiaoTiHei;
  margin: auto;
  margin-top: .5rem;
  font-size: 0.36rem;
  color: #FF6E00;
  width: 2rem;
  height: .6rem;
  text-align: center;
  line-height: .6rem;
  background: #FFFFFF;
  border-radius: 3%;
}
.box_content_info {
  width: 100%;
  /* width: 100vw; */
  /* height: 10.44rem; */
  background: #FAFAFA;
}
.content_info_list {
  padding-top: .3rem;
  margin: auto;
  width: 63%;
  /* width: 100vw; */
  /* height: 10.44rem; */
  /* background: #FFE6D3; */
}
.info_list_title {
  margin: auto;
  width: 100%;
  font-size: .2rem;
  /* width: 100vw; */
  height: .7rem;
  line-height: .7rem;
  /* background: red */
  border-bottom: 1px solid #c1c1c1;
}
.info_list_text {
  display: flex;
  width: 100%;
  /* height: 4rem; */
  /* border: 1px solid black; */
}
.list_text_left {
  text-indent: .48rem;
  padding-left: .7rem;
  padding-top: .8rem;
  width: 50%;
  height: 5.5rem;
  font-size: 0.24rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #999999;
  line-height: 0.45rem;
  /* border: 1px solid black; */
}
.list_text_right {
  margin-left: .4rem;
  width: 4.1rem;
  height: 6.2rem;
  /* border: 1px solid black; */
}
.info_list_code {
  height: 4rem;
  width: 100%;
  /* border: 1px solid black; */
}
.list_code_img {
  margin: .8rem auto;
  margin-bottom: .4rem;
  width: 2.6rem;
  height: 2.6rem;
  /* border: 1px solid black; */
}
.list_code_text {
  margin: 0 auto;
  width: 2rem;
  height: .5rem;
  font-size: 0.22rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;

}
.info_list_conter {
  padding-top: .3rem;
  display: flex;
  justify-content: space-around;
  margin: auto;
  width: 100%;
  font-size: .2rem;
  height: 4rem;
  /* border: 1px solid black; */
}

.list_conter_img {
  width: 2.1rem;
  height: 3.8rem;
  /* border: 1px solid black; */
}
.frist_box_foot {
  width: 100%;
  /* width: 100vw; */
  height: 2.05rem;
  background: #3F3E3E;
}
.box_foot_text {
  position: relative;
  width: 100%;
  /* width: 100vw; */
  height: .41rem;
  line-height: .41rem;
  text-align: center;
  font-size: 0.15rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #b1b1b1;
}
.box_foot_text .imgs {
  width: 0.16rem;
  height: 0.16rem;
  display: inline-block;
  vertical-align: middle;
  position: absolute;
  left: 44.25%;
  /* top: 0.02rem; */
}
.box_foot_text .infos {
  display: inline-block;
}
.conter_rz {
  margin:.65rem auto;
  cursor: pointer;
  width: 1.75rem;
  height: 0.66rem;
  background: #FF6E00;
  box-shadow: 0rem 0.13rem 0.3rem 0rem #FFE1C2;
  border-radius: 0.02rem;
  font-size: 0.3rem;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #FFFFFF;
  line-height: 0.66rem;
  text-align: center;
}
img {
  width: 100%;
  height: 100%;
}
</style>